import React from 'react';

function PricingFree() {
    return (
        <>
            <div className='py-5 px-6 has-text-centered greyBox is-flex is-flex-direction-column is-justify-content-space-between'>
                <div className='is-flex is-flex-direction-column is-justify-content-space-between'>
                    <div>
                        <h3 className='py-2 m-0'>Lightweight legend</h3>
                        <p className='pb-0 mb-0'>For those who like to keep it simple, minimal, and free. Just like your friend's Wi-Fi password.</p>
                    </div>
                    <div>
                        <h1 className='m-0 py-5 colorBlack border-bottom'>Free</h1>
                        <div className='mt-3 mb-3'>
                            <p className='my-2 pt-3 is-semibold'>Features include</p>
                            <p className='my-1 p-0'>Unlimited Nudges</p>
                            <p className='my-1 p-0'>Snooze Nudges</p>
                        </div>
                    </div>
                </div>
                
                <div className="py-5 button-container">
                    <a href="/sign-up" className="button">Let's get this party started</a>
                </div>
            </div>
        </>
    )
}

export default PricingFree;